module.exports = __webpack_public_path__ + "img/dexmo-icon.911ba966.png";